<p-sidebar [(visible)]="visible"
		   position="right"
		   [modal]="true"
		   [dismissible]="true"
		   [showCloseIcon]="false"
		   [style]="panelStyle"
		   styleClass="cmd-drawer"
		   (onHide)="close()">
	<div class="cmd-shell" *ngIf="slotContext">
		<header class="cmd-header">
			<div class="cmd-header__main">
				<div class="cmd-header__eyebrow">
					<span class="cmd-header__eyebrow-title">Driver Assignment</span>
					<p-tag [value]="slotContext.staffingStatusLabel"
						   [severity]="staffingTagSeverity"
						   styleClass="cmd-header__staffing-tag"></p-tag>
				</div>
				<h2 class="cmd-header__title">Manage Assigned Drivers</h2>
				<p class="cmd-header__subtitle">Assign drivers to this route slot for the selected date.</p>
				<hr class="cmd-header__rule" />
				<div class="cmd-header__meta">
					<div class="cmd-meta-item">
						<span class="cmd-meta-item__icon-wrap" aria-hidden="true">
							<i class="pi pi-calendar cmd-meta-item__icon"></i>
						</span>
						<div class="cmd-meta-item__text">
							<span class="cmd-meta-item__label">Date</span>
							<span class="cmd-meta-item__value">{{ dateLabel }}</span>
						</div>
					</div>
					<div class="cmd-meta-item">
						<span class="cmd-meta-item__icon-wrap" aria-hidden="true">
							<i class="pi pi-directions cmd-meta-item__icon"></i>
						</span>
						<div class="cmd-meta-item__text">
							<span class="cmd-meta-item__label">Route</span>
							<span class="cmd-meta-item__value cmd-meta-item__value--ellipsis"
								  [title]="slotContext.routeName">{{ slotContext.routeName }}</span>
						</div>
					</div>
					<div class="cmd-meta-item">
						<span class="cmd-meta-item__icon-wrap" aria-hidden="true">
							<i class="pi pi-clock cmd-meta-item__icon"></i>
						</span>
						<div class="cmd-meta-item__text">
							<span class="cmd-meta-item__label">Departure</span>
							<span class="cmd-meta-item__value">{{ slotContext.departureLabel }}</span>
						</div>
					</div>
					<div class="cmd-meta-item">
						<span class="cmd-meta-item__icon-wrap" aria-hidden="true">
							<i class="pi pi-map-marker cmd-meta-item__icon"></i>
						</span>
						<div class="cmd-meta-item__text">
							<span class="cmd-meta-item__label">Direction</span>
							<span class="cmd-meta-item__value cmd-meta-item__value--ellipsis"
								  [title]="slotContext.directionLabel">{{ slotContext.directionLabel }}</span>
						</div>
					</div>
				</div>
			</div>
			<button pButton
					type="button"
					icon="pi pi-times"
					class="p-button-rounded p-button-text cmd-header__close"
					(click)="close()"
					[attr.aria-label]="'Close'"></button>
		</header>

		<section class="cmd-filters">
			<span class="p-input-icon-left cmd-filters__search-wrap">
				<i class="pi pi-search"></i>
				<input pInputText
					   type="text"
					   class="cmd-filters__search"
					   placeholder="Search by name, mobile number, or plate"
					   [(ngModel)]="searchQuery" />
			</span>
			<div class="cmd-filters__dropdowns">
				<p-dropdown [options]="vehicleModelOptions"
							[(ngModel)]="vehicleModelFilter"
							optionLabel="label"
							optionValue="value"
							placeholder="All vehicle models"
							styleClass="w-full cmd-filters__dropdown"></p-dropdown>
				<p-multiSelect [options]="statusOptions"
							   [(ngModel)]="statusFilter"
							   optionLabel="label"
							   optionValue="value"
							   placeholder="All driver statuses"
							   styleClass="w-full cmd-filters__dropdown"
							   [showHeader]="false"
							   [filter]="false"></p-multiSelect>
			</div>
			<p class="cmd-filters__summary">
				<span class="cmd-filters__summary-strong">{{ selectedCount }} Selected</span>
				<span class="cmd-filters__summary-sep">•</span>
				<span>{{ shownCount }} Shown</span>
			</p>
		</section>

		<div *ngIf="loading" class="cmd-loading">
			<p-progressSpinner strokeWidth="4" animationDuration=".8s"></p-progressSpinner>
		</div>

		<div class="cmd-list" *ngIf="!loading">
			<ng-container *ngFor="let driver of filteredDrivers; let last = last">
				<div class="cmd-driver-row"
					 [class.cmd-driver-row--disabled]="isDriverDisabled(driver)">
					<p-checkbox [(ngModel)]="driver.selected"
								[binary]="true"
								[disabled]="isDriverDisabled(driver)"
								styleClass="cmd-driver-row__check"></p-checkbox>
					<img *ngIf="driver.profileImageUrl && !driver.photoLoadFailed"
						 class="cmd-driver-row__photo"
						 [src]="driver.profileImageUrl"
						 [alt]="driver.name"
						 (error)="onDriverPhotoError(driver)" />
					<div *ngIf="!driver.profileImageUrl || driver.photoLoadFailed"
						 class="cmd-driver-row__avatar"
						 aria-hidden="true">{{ driverInitials(driver.name) }}</div>
					<div class="cmd-driver-row__body">
						<div class="cmd-driver-row__line cmd-driver-row__line--primary">
							<span class="cmd-driver-row__name">{{ driver.name }}</span>
							<span class="cmd-driver-row__mobile">{{ driver.mobile }}</span>
							<span class="cmd-driver-row__status"
								  [ngClass]="availabilityTagClass(driver)">{{ availabilityLabel(driver) }}</span>
						</div>
						<div class="cmd-driver-row__line cmd-driver-row__line--secondary">
							<span class="cmd-driver-row__vehicle">{{ driver.vehicleModel }}</span>
							<span class="cmd-driver-row__plate">
								<span>{{ driver.plateNumber }}</span>
								<ng-container *ngIf="driver.overlapMessage">
									<span class="cmd-driver-row__plate-sep">·</span>
									<span class="cmd-driver-row__overlap">{{ driver.overlapMessage }}</span>
								</ng-container>
							</span>
						</div>
					</div>
					<span class="cmd-driver-row__overlap-badge"
						  *ngIf="driver.hasOverlap">OVERLAP</span>
				</div>
				<hr class="cmd-list__divider" *ngIf="!last" />
			</ng-container>
		</div>

		<footer class="cmd-footer">
			<p class="cmd-footer__hint">
				Assigned drivers determine the bookable capacity of this slot in the Customer App.
			</p>
			<div class="cmd-footer__actions">
				<button pButton
						type="button"
						label="Cancel"
						class="p-button-text cmd-footer__btn-cancel"
						(click)="close()"></button>
				<button pButton
						type="button"
						icon="pi pi-save"
						label="Save assigned drivers"
						class="cmd-footer__btn-save"
						[loading]="saving"
						[disabled]="saving || loading"
						(click)="onSave()"></button>
			</div>
		</footer>
	</div>
</p-sidebar>

<p-dialog [(visible)]="overlapDialogVisible"
		  [modal]="true"
		  [showHeader]="false"
		  [closable]="false"
		  [draggable]="false"
		  [resizable]="false"
		  [appendTo]="'body'"
		  [dismissableMask]="true"
		  [style]="{ width: 'min(560px, calc(100vw - 32px))' }"
		  styleClass="cmd-overlap-dialog"
		  (onHide)="cancelOverlapDialog()">
	<div class="cmd-overlap-dialog__panel">
		<div class="cmd-overlap-dialog__header">
			<span class="cmd-overlap-dialog__icon-wrap" aria-hidden="true">
				<i class="pi pi-exclamation-triangle cmd-overlap-dialog__icon"></i>
			</span>
			<h2 class="cmd-overlap-dialog__title">Assigned Drivers Conflict Detected</h2>
		</div>
		<div class="cmd-overlap-dialog__content">
			<p class="cmd-overlap-dialog__message"
			   *ngFor="let conflict of overlapConflicts">{{ overlapConflictMessage(conflict) }}</p>
		</div>
		<div class="cmd-overlap-dialog__footer">
			<button pButton
					type="button"
					label="Cancel"
					class="p-button-outlined cmd-overlap-dialog__btn-cancel"
					[disabled]="saving"
					(click)="cancelOverlapDialog()"></button>
			<button pButton
					type="button"
					label="Add Anyway"
					class="cmd-overlap-dialog__btn-confirm"
					[loading]="saving"
					[disabled]="saving"
					(click)="confirmOverlapAddAnyway()"></button>
		</div>
	</div>
</p-dialog>
